import React from 'react';
import { Users } from 'lucide-react';
import { cn } from '../../lib/utils';

interface DefaultGroupImageProps {
  className?: string;
}

export const DefaultGroupImage: React.FC<DefaultGroupImageProps> = ({ className }) => {
  return (
    <div
      className={cn(
        "flex items-center justify-center bg-gradient-to-br from-[#5e60ce] to-[#2bc0c7]",
        className
      )}
    >
      {/* Circle with users icon inside - sized relative to container */}
      <div className="h-[55%] aspect-square rounded-full border-[1.5px] border-white/40 flex items-center justify-center">
        <Users className="w-[60%] h-[60%] text-white/40" strokeWidth={1.5} />
      </div>
    </div>
  );
};

